import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import { Table } from 'reactstrap';

import Button from 'components/App/Button';
import Loading from 'components/App/Loading';

import INITIAL_VALUE from 'constants/initialValue';

import { getTotalReviewCount } from 'utils';
import styles from './DataTableDiscovery.module.scss';

const getDestination = (discovery) => discovery.discoverProvince?.name || '-';

function DataTableDiscovery(props) {
  const {
    isLoadingDiscoveryList,
    discoveries,
    onDeleteDiscovery,
    onViewDiscoveryDetail,
  } = props;

  const renderActions = useCallback((itemId, item) => (
    <div className="d-flex gap-3 mt-3">
      <Button
        outline
        classes="Action__Button Action__Button__Danger"
        onClick={() => onDeleteDiscovery(itemId, item)}
      >
        Xóa
      </Button>

      <Button
        outline
        classes="Action__Button Action__Button__Link"
        onClick={() => onViewDiscoveryDetail(itemId, item)}
      >
        Xem chi tiết
      </Button>
    </div>
  ), [onDeleteDiscovery, onViewDiscoveryDetail]);

  const columns = [
    {
      header: 'Tên điểm khám phá',
      render: (item) => (
        <div className="d-flex">
          <img
            src={item.previewImage}
            alt={item.name}
            className="Table__Body__Row__Content__Image"
          />

          <div>
            <div className="Table_Name">{item.name}</div>
            <div className="Action">
              {renderActions(item._id, item)}
            </div>
          </div>
        </div>
      ),
    },
    {
      header: 'Hạng mục',
      render: (item) => (
        item.discoverCategories?.length > 0
          ? (
            <div className="d-flex gap-2">
              <span>{item.discoverCategories[0].name}</span>
            </div>
          )
          : '-'),
    },
    {
      header: 'Điểm đến',
      render: (item) => (
        <div>{getDestination(item)}</div>
      ),
    },
    {
      header: 'Trạng thái',
      render: (item) => (
        <div>
          <span className={item.isPublished ? 'text-success' : 'text-danger'}>
            {item.isPublished ? 'Đang hoạt động' : 'Đã xoá'}
          </span>
        </div>
      ),
    },
    {
      header: 'Lượt đánh giá',
      render: (item) => (
        <div>{getTotalReviewCount(item)}</div>
      ),
    },
    {
      header: 'Điểm đánh giá',
      render: (item) => (item.ratingOverview ? (
        <div>
          <span className="Table_Score">{item.ratingOverview}</span>
          <span className="Table_Score__Divider">
            {' '}
            /5
          </span>
        </div>
      ) : '-'),
    },
  ];

  return (
    <div className={styles.Component}>
      <Loading loading={isLoadingDiscoveryList} loaderOnPage />

      <Table responsive className="table custom_table">
        <thead>
          <tr>
            {columns.map((item) => (
              <th key={`${item.header}header`}>{item.header}</th>
            ))}
          </tr>
        </thead>

        <tbody className="Table__Body">
          {discoveries.map((discovery) => (
            <tr className="Table__Body__Row" key={`${discovery._id}row`}>
              {columns.map((item) => (
                <td
                  key={`${discovery._id}${item.header}content`}
                  className="Table__Body__Row__Content"
                >
                  {item.render(discovery)}
                </td>
              ))}
            </tr>
          ))}

          {discoveries.length === 0 && (
            <tr className="Table__Body__Row">
              <td
                className="Table__Body__Row__Content text-center"
                colSpan={columns.length}
              >
                Không có dữ liệu
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

DataTableDiscovery.propTypes = {
  isLoadingDiscoveryList: PropTypes.bool,
  discoveries: PropTypes.instanceOf(Array),
  onDeleteDiscovery: PropTypes.func,
  onViewDiscoveryDetail: PropTypes.func,
};

DataTableDiscovery.defaultProps = {
  isLoadingDiscoveryList: false,
  discoveries: [],
  onDeleteDiscovery: INITIAL_VALUE.FUNCTION,
  onViewDiscoveryDetail: INITIAL_VALUE.FUNCTION,
};

export default memo(DataTableDiscovery);
